module.exports = __webpack_public_path__ + "static/event-1-1a3aaca174e8c4ccfb3859a5ddfc95f1.jpg";